import React from 'react'
import { REQUEST_USE_CASE } from '@trustero/trustero-api-web/lib/request/request_pb'
import { REQUEST_USE_CASE_TO_LABEL } from 'src/pages/Requests/requests.constants'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

const REQUEST_TYPE_FILTER_VALUES = [
  {
    value: String(REQUEST_USE_CASE.REQUEST_FOR_EVIDENCE),
    label: REQUEST_USE_CASE_TO_LABEL[REQUEST_USE_CASE.REQUEST_FOR_EVIDENCE],
  },
  {
    value: String(REQUEST_USE_CASE.REQUEST_FOR_INFORMATION),
    label: REQUEST_USE_CASE_TO_LABEL[REQUEST_USE_CASE.REQUEST_FOR_INFORMATION],
  },
  {
    value: String(REQUEST_USE_CASE.REQUEST_FOR_ACTION),
    label: REQUEST_USE_CASE_TO_LABEL[REQUEST_USE_CASE.REQUEST_FOR_ACTION],
  },
  {
    value: String(REQUEST_USE_CASE.REQUEST_FOR_VENDOR_ATTESTATION),
    label:
      REQUEST_USE_CASE_TO_LABEL[
        REQUEST_USE_CASE.REQUEST_FOR_VENDOR_ATTESTATION
      ],
  },
  {
    value: String(REQUEST_USE_CASE.REQUEST_FOR_POLICY_DOCUMENT),
    label:
      REQUEST_USE_CASE_TO_LABEL[REQUEST_USE_CASE.REQUEST_FOR_POLICY_DOCUMENT],
  },
]

export const RequestTypeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <FilterDropdown
      filterParam={FilterParam.REQUEST_USE_CASE_TYPE}
      filterName={FilterName.REQUEST_USE_CASE_TYPE}
      filterValues={REQUEST_TYPE_FILTER_VALUES}
      isNested={isNested}
    />
  ),
)

RequestTypeFilterDropdown.displayName = 'RequestTypeFilterDropdown'
